import React from "react";
import { Grid, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";

import style from "./index.module.css";

import SectionHeader from "@/views/Patient/HealthHub/SectionHeader";
import DiseaseCard from "@/views/Patient/HealthHub/DiseaseListSection/DiseaseCard";
import SectionContainer from "@/views/Patient/HealthHub/SectionContainer";

import { IHealthHubDiseasesResult } from "@/models/ApiRequestResponse/patient";

type DiseaseListSectionProps = {
  data: IHealthHubDiseasesResult;
};

const DiseaseListSection: React.FC<DiseaseListSectionProps> = ({ data }) => {
  const navigate = useNavigate();

  const handleDiseaseClick = (diseaseId: string) =>
    navigate(`/health-hub/disease?diseaseId=${diseaseId}`);

  return (
    <SectionContainer>
      <Grid
        item
        className={style.container}
        sx={{
          padding: { xs: "0 0.5rem", sm: "0.2rem 0", md: "1.2rem 0 0 0" },
          maxWidth: { xs: "95%", sm: "100%" },
        }}
      >
        <Grid item>
          <SectionHeader title={data.name} />
        </Grid>
        <Grid item className={style.diseaseContainer}>
          {data.data.map((disease) => (
            <Tooltip key={disease.id} title={disease.name} arrow>
              <Grid
                item
                key={disease.id}
                className={style.diseaseCard}
                onClick={() => handleDiseaseClick(disease.id)}
              >
                <DiseaseCard {...disease} imageUrl={disease.icon_url} />
              </Grid>
            </Tooltip>
          ))}
        </Grid>
      </Grid>
    </SectionContainer>
  );
};

export default DiseaseListSection;
